import { getDefaultRequestState } from '@Features/utils/getDefaultRequestState';
import { ValidationSetting } from '@Types/api/form';
import { RequestFormHeader } from '@Types/index';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LeaveRequestState {
  leaveRequest: RequestFormHeader;
  validationSettings: Array<ValidationSetting>;
}

const initialState: LeaveRequestState = {
  leaveRequest: getDefaultRequestState(),
  validationSettings: [],
};

const leaveRequestSlice = createSlice({
  name: 'leaveRequest',
  initialState,
  reducers: {
    setLeaveRequest: (
      state: LeaveRequestState,
      action: PayloadAction<RequestFormHeader | null>
    ) => {
      const { payload } = action;

      if (payload === null) {
        state.leaveRequest = getDefaultRequestState();
      } else {
        state.leaveRequest = payload;
      }
    },
    setValidationSettings: (
      state: LeaveRequestState,
      action: PayloadAction<Array<ValidationSetting>>
    ) => {
      state.validationSettings = action.payload;
    },
  },
});

const { actions } = leaveRequestSlice;

export const leaveRequestActions = {
  ...actions,
};

export default leaveRequestSlice;
